"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClipboard = void 0;
var react_1 = require("react");
var useClipboard = function () {
    var isSupported = (0, react_1.useMemo)(function () {
        return !!navigator.clipboard;
    }, [navigator]);
    var writeText = (0, react_1.useCallback)(function (text) {
        return navigator.clipboard.writeText(text);
    }, [navigator]);
    var readText = (0, react_1.useCallback)(function () {
        return navigator.clipboard.readText();
    }, [navigator]);
    return {
        writeText: writeText,
        readText: readText,
        isSupported: isSupported,
    };
};
exports.useClipboard = useClipboard;
